let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lOQv1")).then(() => parcelRequire('a5bGE'));